import { Enum } from '../../../platform/Enum';

export const ShapeKind = Enum({
    rectangle: 1,
    oval: 2,
    triangle: 3,
    rightangle: 4,
    rhombus: 5,
    pentagon: 6,
    hexagon: 7,
    octagon: 8,
    paragram: 9,
    heart: 10,
    arrow1: 11,
    arrow2: 12,
    arrow3: 13,
    arrow4: 1301,
    trapezoid: 14,
    quote: 15,
    star: 16,
    badge: 17,
    banner1: 1800,
    banner2: 1801,
    banner3: 1802,
    banner4: 1803,
    banner5: 1804,
    banner6: 1805,
    brace: 1900,
    squareBrace: 1901,
    cloud: 2000,
});

export type ShapeKind = typeof ShapeKind[keyof typeof ShapeKind];

export const ShapeStyle = Enum({
    fill: 0 as const,
    outline: 1 as const,
    dash: 2 as const,
    stroke: 3 as const,
    fillWhite: 4 as const,
});

export type ShapeStyle = typeof ShapeStyle[keyof typeof ShapeStyle];
